<template>
    <div :class="phoneClass || 'dealer-list-container'">
        <content-header>
            <template v-if="!phoneClass">
                <el-button type="primary" class="normal-button" style="margin-right:10px;" @click="downloadFile">
                    <img src="../../assets/img/btn/icon-download.png">
                    <span class="text">{{$t("sideBar.download")}}</span>
                </el-button>
                <el-upload style="display:inline-block;margin-right:5px;"
                           :action="fileUrl"
                           :on-success="onFileUploadSuccessEvent"
                           :before-upload="beforeAvatarUpload"
                           ref="el-upload"
                           :show-file-list="false" :auto-upload="true">
                    <el-button  class="normal-button" style="background-color: transparent;border-color: #fff;margin-right:5px;">
                        <img src="../../assets/img/btn/icon-export.png">
                        <span class="text" style="color:#fff;">{{$t("sideBar.upload")}}</span>
                    </el-button>
                </el-upload>

                <el-button type="primary" class="normal-button" @click="goDealerEdit">
                    <img src="../../assets/img/btn/icon-add.png">
                    <span class="text">{{$t("sideBar.newDealers")}}</span>
                </el-button>
            </template>
        </content-header>
        <div class="dealer-table">
            <div class="search-bar">
                <div class="search-left">
                    <div class="status-index" >
                        <span class="top-title">{{$t("dealerPage.region")}}</span>
                        <el-cascader :options="regionData"
                                     clearable
                                     v-model="pcc"
                                     :placeholder="$t('message.select')"
                                     :props="regionProps"
                                     @change="initPage(),regionChange()">
                        </el-cascader>
                    </div>
                </div>
                <div class="search-right">
                    <div class="status-index" >
                        <el-input
                            :placeholder="$t('dealerPage.find')"
                            @change="initPage(),getAgentList()"
                            v-model="searchForm.key">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                </div>
            </div>
            <div class="phone-dealer-table-list" v-if="phoneClass">
                <div class="phone-dealer-table-item" v-for="(item, index) in agentList" :key="index">
                    <div class="dealer-tab-title">
                        {{item.skf_auth_code }}
                    </div>
                    <div class="dealer-tab-inner">
                        <img src="../../assets/img/phoneIcon/icon1.png">
                        {{ item.contact_name }} {{ item.phone ? '| ' + item.phone : '' }}
                    </div>
                    <div class="dealer-tab-inner">
                        <img src="../../assets/img/phoneIcon/position.png">
                        {{ item.contact_name }}
                    </div>
                    <div class="dealer-tab-inner">
                        <img src="../../assets/img/phoneIcon/icon3.png">{{ item.contact_name }}
                        {{ item.create_time | timeFormat(1)}}
                    </div>
                </div>
            </div>
            <div class="table-outer" v-else>
                <el-table :data="agentList" :header-cell-style="{background:'#fafbfc'}" class="normal-table" style="width: 100%">
                    <el-table-column prop="skf_auth_code" min-width="130px" :label="$t('dealerPage.empower')" ></el-table-column>
                    <el-table-column prop="name" min-width="120px" :label="$t('dealerPage.name')"></el-table-column>
                    <!--地区-->
                    <el-table-column min-width="150px" :label="$t('dealerPage.region')">
                        <template slot-scope="scope" >
                            {{scope.row.province}}{{scope.row.city}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" min-width="90px"  :label="$t('dealerPage.address')"></el-table-column>
                    <el-table-column prop="contact_name" :label="$t('dealerPage.contacts')"></el-table-column>
                    <!--邮箱 -->
                    <el-table-column prop="phone" min-width="110px" :label="$t('dealerPage.phone')"></el-table-column>
                    <el-table-column min-width="170px" prop="email" :label="$t('dealerPage.email')"></el-table-column>
                    <el-table-column prop="device_count" :label="$t('dealerPage.number')"></el-table-column>
                    <el-table-column prop="device_model[0]" min-width="150px" :label="$t('dealerPage.deviceType')"></el-table-column>
                    <el-table-column width="160px" :label="$t('dealerPage.createTime')">
                        <div slot-scope="scope">
                            {{scope.row.create_time | timeFormat(1)}}
                        </div>
                    </el-table-column>
                    <el-table-column  prop="is_enable" :label="$t('dealerPage.operation')" fixed="right" width="100" v-if="user.role === 10?false:true && role">
                        <div slot-scope="scope" class='my-table-button'>
                            <img src="../../assets/img/icon/authority-set.png" @click="editAgent(scope.row)">
                            <img src="../../assets/img/icon/authority-no.png" v-if="!scope.row.is_enable"  @click="deleteAgent(scope.row)">
                            <img src="../../assets/img/icon/authority-off.png" v-else  @click="deleteAgent(scope.row)">
                            <!--is_enable    返回的是0  启用   1 禁用 -->
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination" style="text-align:right;padding:20px;">
                <el-pagination 
                    @current-change="pageChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total"
                    background>
                </el-pagination>
            </div>
        </div>
    </div>
</template>


<script>
import Core from "core/core";
import contentHeader from '../../components/content-header'
import region from "core/region"
import {refresh} from "core/winSize"
// import axios from 'axios';
import REGION from '@/assets/ext/region-code.json';
export default {
    data() {
        return {
	        phoneClass: '',
            user: '',
            agentList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            searchForm: {
                key: '',
                status: '',
                site: '',
                dealer: ''
            },
            deviceStatusList: [
                {label: '全部',value: 0}
            ],
            loadingL: '',
            fileUrl: Core.Const.NET.IMPORT_FILE + 'import-agent',
            regionData: [],
            pcc: [],
            regionProps: {
                value: 'name',
                label: 'name'
            },
            province: '',
            city: '',
            role: false
        };
    },
    components: {
        contentHeader
    },
    created(){
	    refresh(this,'phoneClass-dealer-list-container');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-dealer-list-container');
		    },10)
	    };
    },
    mounted() {
	    this.initRegion()
        this.initUserData()
        this.getAgentList();
    },
    computed: {
    },
    methods: {
	    initRegion() {
            let list = REGION.zh
		    list.map(province => {
			    province.children.map(city => delete city.children)
		    })
		    this.regionData = list
	    },
        regionChange() {
            let [province, city, county] = this.pcc
            this.province = province
            this.city = city;
            this.getAgentList()
            // this.editForm.county = county
        },
        goDealerEdit() {
            this.$router.push('/dealer/add')
        },
        initUserData() {
            let token = Core.Data.getToken()
            this.user = Core.Data.getUser()
            // console.log(user,'user');
            this.user.role === 100 || Core.Data.getUser().role === 101 || Core.Data.getUser().role === 102 ? this.role = false : this.role = true
            this.fileUrl += '?user_id='+ this.user.id
        },
        getAgentList() {
            Core.Api.Agent.list(this.currentPage,this.province,this.city,this.searchForm.key).then(res => {
                // console.log(res,"###");
                let agentList = res.agent_list;
                this.agentList = agentList;
                this.total = res.count;

            })
        },
        pageChange(val) {
            this.currentPage = val;
            this.getAgentList();
        },
        deleteAgent(row) {
            if(!row.is_enable){
                this.$confirm('您确定要禁用该服务商吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    Core.Api.Agent.enable(row.id).then((res)=>{
                        this.getAgentList()
                        this.$message({
                            type: 'success',
                            message: '禁用成功!'
                        });
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消禁用'
                    });
                });
            } else {
                Core.Api.Agent.enable(row.id).then((res)=>{
                    this.getAgentList()
                })
            }
        },
        editAgent(row) {
            if(!row.id) {
                return
            }
            this.$router.push(`/dealer/add?dealer_id=${row.id}`)
        },
        downloadFile() {
            const lang = Core.Data.getLang() || 'zh'
            window.open(`/template/${lang}/agent-excel-template.xlsx`);
        },
        onFileUploadSuccessEvent(res, file, fileList){
            // console.log(this.fileUrl,'url');
            console.log(res,'dealerRes');
            if(res && res.code) {
                this.$message.error('导入失败,请查看文件内容格式')
            }else {
                if (res.data.fail_list[0]) {
                    let msg = ''
                    for(let i in res.data.fail_list) {
                        let item = res.data.fail_list[i]
                        item.imei ? msg += 'Excel表格第'+item.row_num+'行，'+ Object.keys(item)[1] +':'+item.imei+'，'+item.message+'</br>'
                            : msg += 'Excel表格第'+item.row_num+'行，' + Object.keys(item)[1] + ': &nbsp;&nbsp; ，'+item.message+'</br>'
                        // : msg += '第'+item.row_num+'行，'+item.message+'</br>'
                        // msg += '第'+item.row_num+'行，编号:'+item.imei+'，'+item.message+'</br>'
                    }
                    let div = '<div style="min-height:300px;height:50vh;overflow: auto">' + msg + '</div>'
                    this.$alert(div, '服务商未导入原因：', {
                        dangerouslyUseHTMLString: true
                    });
                } else {
                    this.$message.success('导入成功');
                }
                this.getAgentList();

            }
            this.loading.close();
            // console.log(response, file, fileList)
        },
        initPage(){
            this.currentPage = 1
        },
        beforeAvatarUpload(file){
	        console.log(file.name.substr(file.name.lastIndexOf(".")),'文件格式')
	        let EXCEL = file.name.substr(file.name.lastIndexOf("."))
	        let isEXCEL  = EXCEL === '.xls' || EXCEL === '.xlsx'
            if (isEXCEL){
                this.loading= this.$loading({
                    lock: true,
                    text: 'Up loading'
                })
            } else {
                this.$message.error('请导入excel表格')
                return isEXCEL;
            }
        },
    },


};
</script>

<style scoped lang="scss">
@import '../../assets/style/mixin.scss';
.dealer-list-container {
    background-color: #E5EBEF;
    height: 100%;
    .dealer-table {
        margin: 30px 40px;
        background-color: #FFFFFF;
        .search-bar {
            @include flex-sb;
            padding: 20px;
            .status-index {
                margin-right: 12px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .table-outer {
            padding: 0 20px;
        }
    }
    .normal-button {
        background-color: transparent;
        border-color: #FFFFFF;
        img {
            width: 13px;
            height: 13px;
            vertical-align: middle;
        }
        .text {
            font-size: 14px;
            color: #FFFFFF;
            vertical-align: middle;
            margin-left: 8px;
            line-height: 20px;
        }
    }
}
</style>

<style lang="scss">
    .dealer-list-container {
        .table-outer {
            .cell {
                white-space:nowrap;
                overflow:hidden; //超出的文本隐藏
                text-overflow:ellipsis; //溢出用省略号显示
            }
            .cell:hover {
                /*background: #e2e2e2;*/
                white-space: normal;
                overflow: visible; //超出的文本隐藏
                position: relative;
                z-index: 10000;
                text-overflow:clip;
                /*background: #f6f7fb;*/
            }

        }
    }
    .my-table-button img{
        cursor: pointer;
    }
.status-index {
    display: inline-block;
    /*vertical-align: middle;*/
    .top-title {
        border: 1px solid rgba(7, 17, 27, .1);
        border-right: none;
        border-radius: 4px 0 0 4px;
        min-width: 60px;
        height: 32px;
        background-color: #F5F7F9;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #80868B;
        cursor: pointer;
    }
    .el-select {
        width: 243px;
        .el-input__inner {
            height: 32px;
            /*width: 243px;*/
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
    .el-input__inner {
        height: 32px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .input-index {
        position: relative;
        img {
            position: absolute;
            width: 20px;
            height: 20px;
            top: 8px;
            right: 8px;
            cursor: pointer;
        }
        .el-input__inner {
            width: 300px;
            height: 34px;
            box-sizing: border-box;
            border-radius: 3px;
            padding-right: 30px;
        }
    }
    .el-cascader {
        .el-input__inner {

            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
}
.phoneClass-dealer-list-container {
    padding-bottom: 52px;
    .search-bar {
        padding: 0 12px 15px;
        background: white;
        .search-left {
            display: flex;
            flex-direction: column;
        }
        .search-right {
        }
        .status-index {
            margin-top: 15px;
            width: 100%;
            .top-title {
                width: 100px;
            }
            .el-select, .el-input, .el-cascader {
                flex: 1;
            }
            .el-date-editor {
                margin-left: 0 !important;
                min-width: 300px;
                width: 100%;
                //max-width: 90vw;
            }
        }
    }

    .phone-dealer-table-list {
        padding: 12px 12px 0;
        .phone-dealer-table-item {
            background: white;
            margin-bottom: 12px;
            padding: 12px 17px;
            border-radius: 4px;
            .dealer-tab-title {
                font-size: 16px;
                font-weight: 500;
                color: #2D2E32;
                border-bottom: 1px solid #EDF0F3;
                padding-bottom: 12px;
                margin-bottom: 10px;
            }
            .dealer-tab-inner {
                display: flex;
                align-items: center;
                margin-bottom: 4px;
                font-size: 14px;
                color: #767A88;
                min-height: 20px;
                &:last-child {
                    margin-bottom: 0;
                }
                img {
                    min-width: 12px;
                    max-width: 12px;
                    min-height: 12px;
                    max-height: 12px;
                    margin-right: 9px;
                }
            }
        }

    }
    .pagination {
        padding: 20px 0 !important;
        text-align: center !important;
        .el-pagination {
            padding: 0;
            button {
                width: 20px;
                min-width: 0;
                height: 30px;
            }
            .el-pager {
                .number {
                    margin: 0 3px !important;
                    padding: 0 !important;
                    min-width: 0px;
                    width: 20px !important;
                    height: 30px !important;
                }
                .el-icon-more {

                    margin: 0 3px !important;
                    padding: 0 !important;
                    min-width: 0px;
                    width: 20px !important;
                    height: 30px !important;
                }
            }
        }
    }
}
</style>
